import Loaders from './ProductHelper/loaders';

/**
 * recently_viewed_helpers.js
 * Helper module to manage recently viewed designs in localStorage.
 * Each entry: { designId, canvasId }
 * Max 7 entries, most recent first.
 */

const RECENTLY_VIEWED_KEY = 'recently_viewed_designs';
const MAX_RECENT = 7;

/**
 * Get the list of recently viewed designs from localStorage.
 * @returns {Array<{designId: integer, canvasId: integer}>}
 */
const getRecentlyViewed = () => {
  try {
    const data = localStorage.getItem(RECENTLY_VIEWED_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

/**
 * Clear recently viewed designs from localStorage except
 * for the given design ID/canvas ID combination.
 * @param {integer} designId
 * @param {integer} canvasId
 * */
const clearExceptCurrent = (designId, canvasId) => {
  let items = getRecentlyViewed();
  if (designId && canvasId) {
    items = items.filter(
      item => (item.designId === designId && item.canvasId === canvasId),
    );
  } else {
    items = [];
  }
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
}


/**
 * Save a design/canvas combination as recently viewed.
 * @param {integer} designId
 * @param {integer} canvasId
 * @param {boolean} recentlyViewedEnabled
 */
const saveRecentlyViewed = (designId, canvasId, recentlyViewedEnabled) => {
  if (!designId || !canvasId || !recentlyViewedEnabled) return;

  let items = getRecentlyViewed();

  // Remove existing entry if present
  items = items.filter(
    item => !(item.designId === designId && item.canvasId === canvasId),
  );

  // Add new entry to the front
  items.unshift({ designId, canvasId });

  // Limit to MAX_RECENT
  if (items.length > MAX_RECENT) items = items.slice(0, MAX_RECENT);

  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
}

/**
 * Show recently viewed designs excluding the current design/canvas.
 * @param {integer} designId
 * @param {integer} canvasId
 * @param {string} recentlyViewedPath
 * @param {boolean} recentlyViewedEnabled
 */
const showRecentlyViewed = (designId, canvasId, recentlyViewedPath, recentlyViewedEnabled) => {
  if (!recentlyViewedEnabled) return;

  const recentlyViewedObjects = getRecentlyViewed()
    .filter(item => item.designId !== designId || item.canvasId !== canvasId)
    .slice(0, MAX_RECENT - 1);
  if (recentlyViewedObjects.length === 0) return;
  const pathWithObjects = `${recentlyViewedPath}?design_id=${designId}&canvas_id=${canvasId}&recently_viewed_objects=${encodeURIComponent(JSON.stringify(recentlyViewedObjects))}`;
  Loaders.loadRecentlyViewedProductImgs(pathWithObjects);
}


export {
  getRecentlyViewed,
  saveRecentlyViewed,
  showRecentlyViewed,
  clearExceptCurrent,
};
